<template>
  <div class="cert-query-page">
    <div class="corner corner-left" aria-hidden="true"></div>
    <div class="corner corner-right" aria-hidden="true"></div>

    <main class="cert-query-stage" aria-label="证书查询系统">
      <header class="query-title">
        <h1>证书查询系统</h1>
        <p>CERTIFICATE QUERY SYSTEM</p>
      </header>

      <form class="cert-query-form" @submit.prevent="inqCert">
        <label class="field-block" for="cert-name">
          <span class="field-label">
            <span class="field-icon icon-name" aria-hidden="true"></span>
            姓名
          </span>
          <input
            id="cert-name"
            v-model="cert.name"
            class="field"
            type="text"
            autocomplete="off"
            placeholder="请输入姓名"
          />
        </label>

        <label class="field-block" for="cert-certid">
          <span class="field-label">
            <span class="field-icon icon-certid" aria-hidden="true"></span>
            证书编号
          </span>
          <input
            id="cert-cardid"
            v-model="cert.certid"
            class="field"
            type="text"
            autocomplete="off"
            placeholder="请输入证书编号"
          />
        </label>

        <label class="field-block" for="cert-cardid">
          <span class="field-label">
            <span class="field-icon icon-card" aria-hidden="true"></span>
            身份证号
          </span>
          <input
            id="cert-cardid"
            v-model="cert.cardid"
            class="field"
            type="text"
            autocomplete="off"
            placeholder="请输入18位身份证号"
          />
        </label>

        <button class="submit-btn" type="submit">查询证书</button>
      </form>
    </main>

    <footer class="query-footer">
      Copyright ©2022：bjrs.org.cn 北京软数信息技术研究院　京ICP备16059467号-5
    </footer>
  </div>
</template>

<script>
import { Message } from "element-ui";

export default {
  metaInfo: {
    title: "证书查询系统",
    meta: [
      {
        name: "viewport",
        content: "width=device-width, user-scalable=yes, initial-scale=1, maximum-scale=1, minimum-scale=1",
      },
    ],
  },
  data() {
    return {
      certType: "person",
      cert: {
        name: "",
        certid: "",
        cardid: "",
      },
    };
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.keyDown, false);
  },
  mounted() {
    window.addEventListener("keydown", this.keyDown);
  },
  methods: {
    inqCert() {
      const name = this.cert.name.trim();
      const certid = this.cert.certid.trim();
      const cardid = this.cert.cardid.trim();

      if (!name) {
        Message.error("请输入姓名！");
        return;
      }
      if (!cardid&&!certid) {
        Message.error("请输入身份证号或证书编号！");
        return;
      }

      const params = [`name=${encodeURIComponent(name)}`];
      if (certid) params.push(`certid=${encodeURIComponent(certid)}`);
      if (cardid) params.push(`cardid=${encodeURIComponent(cardid)}`);
      this.$axios.get(`/api/certificates1/userget?${params.join("&")}`).then((res) => {
        if (res.data.success === true && res.data.data.length > 0) {
          return this.$router.replace(
            encodeURI(`/certResult/?name=${name}&code=${res.data.data[0].certid}&type=${this.certType}`)
          );
        }
        return Message.error("无法查询到此证书，请确认信息是否填写正确！");
      });
    },
    keyDown(e) {
      if (e.keyCode === 13) {
        this.inqCert();
      }
    },
  },
};
</script>

<style scoped>
.cert-query-page,
.cert-query-page:before {
  background-color: #eaf9ff;
}

.cert-query-page {
  position: fixed;
  inset: 0;
  width: 100vw;
  height: 100vh;
  min-height: 720px;
  overflow: hidden;
  background: #eaf9ff url("/static/img/info-query/back.png") center center / cover no-repeat;
  font-family: "Microsoft YaHei", Arial, sans-serif;
}

.cert-query-page:before {
  content: "";
  position: fixed;
  inset: -2px;
  z-index: -1;
}

.corner {
  position: absolute;
  z-index: 0;
  pointer-events: none;
}

.corner-left {
  left: 0;
  bottom: 0;
  width: 636px;
  height: 530px;
  background: url("/static/img/info-query/left.png") left bottom / contain no-repeat;
}

.corner-right {
  right: 0;
  top: 0;
  width: 640px;
  height: 640px;
  background: url("/static/img/info-query/right.png") right top /
    640px 640px no-repeat;
}

.cert-query-stage {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  padding-top: 100px;
  letter-spacing: 3px;
}

.query-title {
  text-align: center;
}

.query-title h1 {
  margin: 0;
  color: #168ff0;
  background: linear-gradient(90deg, #05bff2 0%, #2d92f4 53%, #a668f2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 48px;
  font-weight: 700;
  line-height: 58px;
}

.query-title p {
  margin: 11px 0 0;
  color: rgba(88, 108, 125, 0.47);
  font-size: 18px;
  line-height: 24px;
  letter-spacing: 1.6px;
}

.cert-query-form {
  position: relative;
  width: 598px;
  height: 590px;
  margin-top: 41px;
  padding: 48px;
  box-sizing: border-box;
  border: 1px solid rgba(117, 178, 255, 0.66);
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.88);
  box-shadow: 0 18px 46px rgba(95, 158, 218, 0.16);
}

.cert-query-form:before {
  content: "";
  position: absolute;
  left: 50%;
  bottom: -102px;
  z-index: -1;
  width: 780px;
  height: 520px;
  transform: translateX(-50%);
  background: url("/static/img/info-query/center.png") center bottom / contain no-repeat;
  opacity: 0.62;
  pointer-events: none;
}

.field-block {
  display: block;
  margin: 0 0 32px;
}

.field-label {
  display: flex;
  align-items: center;
  height: 24px;
  margin-bottom: 14px;
  color: #2e3a4c;
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;
}

.field {
  display: block;
  width: 502px;
  height: 58px;
  padding: 0 24px;
  box-sizing: border-box;
  border: 1px solid #abd1ff;
  border-radius: 14px;
  outline: none;
  background: rgba(242, 248, 255, 0.44);
  color: #2c3a4c;
  font-size: 16px;
  line-height: 58px;
}

.field::placeholder {
  color: #9eabbb;
}

.field:focus {
  border-color: #7bb8ff;
  background: rgba(255, 255, 255, 0.64);
}

.field-block select {
  appearance: none;
  -webkit-appearance: none;
}

.submit-btn {
  display: block;
  width: 502px;
  height: 64px;
  margin-top: 72px;
  border: 0;
  border-radius: 12px;
  outline: none;
  background: linear-gradient(90deg, #2786ff 0%, #06b6d2 100%);
  box-shadow: 0 10px 16px rgba(25, 132, 223, 0.32);
  color: #fff;
  cursor: pointer;
  font-size: 16px;
  line-height: 64px;
  text-align: center;
}

.submit-btn:focus {
  box-shadow: 0 0 0 2px rgba(33, 142, 255, 0.18);
}

.field-icon {
  position: relative;
  display: inline-block;
  width: 18px;
  height: 18px;
  margin-right: 8px;
  flex: 0 0 18px;
}

.field-icon:before,
.field-icon:after {
  content: "";
  position: absolute;
  box-sizing: border-box;
}

.icon-name:before {
  left: 6px;
  top: 1px;
  width: 6px;
  height: 6px;
  border: 2px solid #2e3a4c;
  border-radius: 50%;
}

.icon-name:after {
  left: 3px;
  bottom: 1px;
  width: 12px;
  height: 8px;
  border: 2px solid #2e3a4c;
  border-bottom: 0;
  border-radius: 8px 8px 0 0;
}

.icon-certid:before {
  left: 1px;
  top: 1px;
  width: 16px;
  height: 16px;
  border: 2px solid #2e3a4c;
  border-radius: 50%;
}

.icon-certid:after {
  left: 7px;
  top: 7px;
  width: 4px;
  height: 4px;
  border: 2px solid #2e3a4c;
  border-radius: 50%;
}

.icon-card {
  border: 2px solid #2e3a4c;
  border-radius: 2px;
  box-sizing: border-box;
}

.icon-card:before {
  left: 3px;
  top: 5px;
  width: 10px;
  height: 2px;
  background: #2e3a4c;
}

.query-footer {
  position: absolute;
  z-index: 1;
  left: 0;
  right: 0;
  bottom: 15px;
  color: rgba(76, 88, 105, 0.62);
  text-align: center;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 1px;
}

@media (max-width: 900px) {
  .cert-query-stage {
    padding-top: 11vh;
  }

  .query-title h1 {
    font-size: 30px;
    line-height: 38px;
  }

  .query-title p {
    font-size: 12px;
    line-height: 18px;
  }

  .cert-query-form {
    position: relative;
    width: 86vw;
    max-width: 360px;
    height: auto;
    margin-top: 36px;
    padding: 30px 24px;
  }

  .cert-query-form:before {
    bottom: -62px;
    width: 118vw;
    height: 380px;
  }

  .field,
  .submit-btn {
    width: 100%;
  }

  .field-block {
    margin-bottom: 18px;
  }

  .submit-btn {
    margin-top: 28px;
  }
}
</style>
